import React from "react";

import { Flex, Heading, Spacer, Text } from "@kazoohr/confetti";

export function ArchivedAccountPage() {
  return (
    <Flex
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ paddingTop: "4rem", textAlign: "center" }}
    >
      <Heading level="1">Account Archived</Heading>
      <Spacer />
      <Text paragraph>You no longer have access to Constellation.</Text>
      <Spacer size="small" />
      <Text paragraph>
        Contact{" "}
        <a href="mailto:constellation@worktango.com">
          constellation@worktango.com
        </a>{" "}
        for support.
      </Text>
    </Flex>
  );
}
